import { render } from "./TranslationOptions.vue?vue&type=template&id=02a7e7f6&scoped=true"
import script from "./TranslationOptions.vue?vue&type=script&lang=js"
export * from "./TranslationOptions.vue?vue&type=script&lang=js"

import "./TranslationOptions.vue?vue&type=style&index=0&id=02a7e7f6&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/translation_system/translation_system/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02a7e7f6"]])

export default __exports__